<template>
  <div class="">
    <div class="columns is-gapless is-mobile mb-0">
        <div class="column is-narrow mr-2">
          <div class="has-text-weight-bold">
            {{ journey.from }}
          </div>
        </div>
        <div class="column is-narrow mr-2">
          <span class="is-size-7 mt-1 is-block">
            <b-icon icon="arrow-right" size="is-small" class="has-text-grey-light"></b-icon>
          </span>
        </div>
        <div class="column is-narrow mr-2">
          <div class="has-text-weight-bold">
            {{ journey.to }}
            </div>
        </div>

        <MultipleAirportsTag
                class="column is-narrow"
                position="is-right"
                v-if="roundTripDifferentAirports && journeyIndex == 1"
              ></MultipleAirportsTag>
      </div>
    <div class="is-size-7 has-text-grey-light">
      {{ $helpers.airlineName(journey.airlineCode) }}
    </div>
    <div class="mt-1 mb-5">
        <div class="is-inline has-text-grey is-size-7">
          {{ journey.legs[0].departingAt.time | formatTime}} - {{ journey.legs.slice(-1).pop().arrivingAt.time | formatTime}} <span class="is-size-7 ml-2 has-text-danger" v-if="journey.dateDifference > 0">
            +{{ journey.dateDifference }}
            <span v-if="journey.dateDifference == 1">day</span>
            <span v-if="journey.dateDifference > 1">days</span>
          </span>
        </div>
        <div class="has-text-grey-light is-size-7">
          <span class="has-text-grey ">{{ journey.travelDuration | formatDuration }}</span> 
          <span class="has-text-grey is-size-7"> {{ journey.legs.length - 1 | formatLayovers}}</span>
          <span
              v-for="(layover, index) in journey.layovers"
              :key="`layover-${index}`"
              class="is-size-7 has-text-grey-light"
            >

              <span class="mx-1 has-text-grey-light">
                &bull;
              </span>

              <span class="has-text-weight-bold" v-bind:class="getLayoverClass(layover.durationInMinutes)">
                {{ layover.airport }} 
              </span>
            
              
              <span v-bind:class="getLayoverClass(layover.durationInMinutes)">
                {{ layover.durationInMinutes | formatDuration }}
              </span>
            </span>
        </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'JourneySummaryAlt',
    components: {
    },
    props: {
        journey: Object
    },
    data: function () {
      return {
        roundTripDifferentAirports: false
      }
    },
    computed: {

    },
    methods: {
      getAirportLocation(airportCode) {
        const airport = this.$globals.airports.find(airportItem => {
          return airportItem.code === airportCode;
        });

        return airport ? `${airport.city}, ${airport.state}` : null;
      },
      getLayoverClass(durationInMinutes) {
        if (durationInMinutes > 180 || durationInMinutes < 45) {
          return 'has-text-danger'
        }

        return ''
      },
    },
    mounted(){
      // console.log(this.journey);
    },
}
</script>
